<template>
  <div>
    <megabit-base-dialog :show-dialog="true">
      <template v-slot:body>
        <v-card color="grey darken-4">
          <v-card-title>
            <div>
              <span class="font-weight-bold text-subtitle-1 white--text"
                >Registrar Unidade de Medida</span
              >
              <span class="font-weight-thin text-subtitle-2 ml-4">(ALT+R)</span>
            </div>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="formValid">
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <base-input
                    label="Código"
                    placeholder="Digite o Código"
                    :minLength="1"
                    :maxLength="5"
                    :isRequired="true"
                    v-model="form.codigo"
                  />
                </v-col>
                <v-col cols="12" sm="8" md="8">
                  <base-input
                    label="Descrição"
                    placeholder="Digite a Descrição"
                    :minLength="1"
                    :maxLength="30"
                    :isRequired="true"
                    v-model="form.descricao"
                  />
                </v-col>
                <v-col cols="12" sm="8" md="8">
                  <base-input
                    label="Fator"
                    placeholder="Digite o fator"
                    :maxLength="30"
                    v-model="form.fator"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <form-buttons @submitForm="submitForm()" @goBack="goBack()"/>
        </v-card>
      </template>
    </megabit-base-dialog>
  </div>
</template>

<script>
import MegabitBaseDialog from '@/components/shared/base-dialog/BaseDialog'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
import { mapActions, mapState } from 'vuex'
import baseInput from '@/components/shared/base-input/BaseInput'
export default {
  components: { MegabitBaseDialog, baseInput, FormButtons },
  data: () => {
    return {
      isUpdate: false,
      formValid: false,
      form: {
        codigo: '',
        descricao: '',
        fator: '',
      },
    }
  },
  computed: {
    ...mapState('measurementUnitsModule', ['measurementUnit']),
  },
  methods: {
    ...mapActions({
      insertAPI: 'measurementUnitsModule/insertAPI',
      getMeasurementUnit: 'measurementUnitsModule/getMeasurementUnitAPI',
      updateAPI: 'measurementUnitsModule/updateAPI',
    }),
    ...mapActions('dialogModule',['setShowLoadingDialog','setLoadingDialogMessage']),
    goBack() {
      this.$router.push({ name: 'measurementUnits' })
    },
    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.$toasted.error('Corrija os campos em vermelho');
        return
      }
      try {
        this.setShowLoadingDialog(true);
        this.setLoadingDialogMessage('Enviando Registro para o Sistema.');
        let response
        if (!this.isUpdate)
          response = await this.insertAPI({
            DESCRICAO: this.form.descricao,
            CODIGO: this.form.codigo,
            FATOR: this.form.fator,
          })
        else
          response = await this.updateAPI({
            data: {
              DESCRICAO: this.form.descricao,
              CODIGO: this.form.codigo,
              FATOR: this.form.fator,
            },
            id: this.$route.params.id,
          })
        this.$toasted.success(response);
        
        this.goBack()
      } catch (error) {
        this.$toasted.error(error, {duration: null})
      } finally {
        this.setShowLoadingDialog(false);
      }
    },
    async mountData() {
      try {
        if (this.$route.params && this.$route.params.id) {
          this.isUpdate = true
          await this.getMeasurementUnit(this.$route.params.id)
          this.form.codigo = this.measurementUnit.CODIGO
          this.form.descricao = this.measurementUnit.DESCRICAO
          this.form.fator = this.measurementUnit.FATOR
        }
      } catch (error) {
        this.$toasted.error(error, {duration: null})
      }
    },
  },
  mounted() {
    this.mountData()
  },
}
</script>

<style></style>
